"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CountryPicker;
var _hopsSdkJs = require("@hps/hops-sdk-js");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = require("react");
var _Select = _interopRequireDefault(require("../Components/Select"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function CountryPicker(props) {
  const [options, setOptions] = (0, _react.useState)(null);
  const [error, setError] = (0, _react.useState)(null);
  const [loading, setLoading] = (0, _react.useState)(true);
  (0, _react.useEffect)(() => {
    _hopsSdkJs.Api.call({
      url: "/api/resources/countries"
    }).then(({
      data
    }) => {
      setOptions(data.map(country => {
        return {
          id: country.Code,
          label: country.Name,
          value: country.Code
        };
      }));
    }).catch(e => {
      setError(e);
    }).finally(() => {
      // Call onChange to re-sync the country state with the selected value
      props.onChange?.(props.value, props.name);
      setLoading(false);
    });
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Select.default, {
    ...props,
    label: props.label || "Country",
    loading: loading,
    loadingError: !!error,
    loadingErrorMessage: "Error loading countries list.",
    options: options || []
  });
}
CountryPicker.propTypes = {
  name: _propTypes.default.string,
  onChange: _propTypes.default.func,
  value: _propTypes.default.string
};